(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/tracking/shared-tracking.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/tracking/shared-tracking.js');
"use strict";


const DEPOSIT_PAY_SUPPORTED_PRODUCTS = svs.accountservicesReact.deposit.constants.DEPOSIT_PAY_SUPPORTED_PRODUCTS;
const {
  SWISH,
  APPLEPAY,
  BANKCARD,
  SWEDBANKEXPRESS
} = svs.accountservicesReact.deposit.constants.paymentTypes;
const getTrackingPaymentType = paymentType => {
  var _paymentType$toLowerC;
  let pt = paymentType === null || paymentType === void 0 || (_paymentType$toLowerC = paymentType.toLowerCase()) === null || _paymentType$toLowerC === void 0 ? void 0 : _paymentType$toLowerC.trim();
  if (pt) {
    switch (pt) {
      case SWISH:
        pt = 'Swish';
        break;
      case BANKCARD:
        pt = 'Bankkort';
        break;
      case APPLEPAY:
        pt = 'Bankkort ApplePay';
        break;
      case SWEDBANKEXPRESS:
        pt = 'Direkt från ditt Bankkonto';
        break;
      default:
        pt = paymentType;
    }
  } else {
    pt = 'Unknown Payment Type';
  }
  return pt;
};

const trackSuccess = async (paymentType, amount, productName) => new Promise(resolve => {
  svs.components.analytics.trackEvent({
    category: 'Deposits',
    action: DEPOSIT_PAY_SUPPORTED_PRODUCTS.includes(productName === null || productName === void 0 ? void 0 : productName.toLowerCase()) ? 'Deposit Success Autopay' : 'Deposit Success',
    opt_label: getTrackingPaymentType(paymentType),
    opt_value: parseInt(amount, 10) || 0
  }, () => {
    resolve();
  });
});

const trackFailure = async (paymentType, errorCode, productName) => new Promise(resolve => {
  svs.components.analytics.trackEvent({
    category: 'Deposits',
    action: DEPOSIT_PAY_SUPPORTED_PRODUCTS.includes(productName) ? 'Deposit Failure Autopay' : 'Deposit Failure',
    opt_label: getTrackingPaymentType(paymentType),
    opt_value: errorCode
  }, () => {
    resolve();
  });
});
svs.accountservicesReact.deposit.tracking.sharedTracking = {
  trackSuccess,
  trackFailure,
  getTrackingPaymentType
};

 })(window);